// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

const {ccclass, property, requireComponent, executeInEditMode, menu} = cc._decorator;

@ccclass
@requireComponent(cc.Graphics)
@executeInEditMode
@menu('Framework/绘图组件/PolygonProgressBar')
export default class PolygonProgressBar extends cc.Component {

    @property(cc.Graphics)
    protected graphics: cc.Graphics = null;

    @property()
    protected _lineWidth: number = 20;
    @property({ tooltip: CC_DEV && '线宽' })
    public get lineWidth() {
        return this._lineWidth;
    }
    public set lineWidth(value: number) {
        this._lineWidth = value;
        this.updateProperties();
    }

    @property()
    protected _lineCap: cc.Graphics.LineCap = cc.Graphics.LineCap.ROUND;
    @property({ type: cc.Graphics.LineCap, tooltip: CC_DEV && '线帽' })
    public get lineCap() {
        return this._lineCap;
    }
    public set lineCap(value: number) {
        this._lineCap = value;
        this.updateProperties();
    }

    @property()
    protected _progress: number = 0.4;
    @property({ range: [0, 1], step: 0.01, tooltip: CC_DEV && '进度 (0 ~ 1)' })
    public get progress() {
        return this._progress;
    }
    public set progress(value: number) {
        this.updateProgress(value);
    }

    @property()
    protected _backgroundColor: cc.Color = new cc.Color(255, 255, 255, 255);
    @property({ type: cc.Color, tooltip: CC_DEV && '背景颜色' })
    public get backgroundColor() {
        return this._backgroundColor;
    }
    public set backgroundColor(value: cc.Color) {
        this._backgroundColor = value;
        this.updateProperties();
    }

    @property()
    _plygonArr: cc.Vec2[] = [];
    @property({type: [cc.Vec2], tooltip: CC_DEV && '多边形'})
    get polygonPoing() {
        return this._plygonArr;
    }
    set polygonPoing(value: cc.Vec2[]) {
        this._plygonArr = value;
        this.updateProperties();
    }

    /**
     * 当前缓动对象
     */
    protected curTween: cc.Tween = null;

    /**
     * 当前缓动的 Promise resolve
     */
    protected curTweenRes: Function = null;


    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

     /**
     * 生命周期：加载
     */
     protected onLoad() {
        this.init();
    }

    /**
     * 编辑器回调：重置
     */
    protected resetInEditor() {
        this.init();
    }

    /**
     * 初始化
     */
    protected init() {
        if (!this.graphics) {
            this.graphics = this.getComponent(cc.Graphics);
        }
        this.updateProperties();
    }

    start () {

    }

    /**
     * 更新属性
     */
    protected updateProperties() {
        // 设置样式
        const graphics = this.graphics;
        graphics.lineWidth = this._lineWidth;
        graphics.lineCap = this._lineCap;
        graphics.strokeColor = this._backgroundColor;
        // 重新绘制进度条
        this.updateProgress(this._progress);
    }


    /**
     * 更新进度
     * @param value 进度值（0~1）
     */
    public updateProgress(value: number) {
        // 处理并保存值
        if (value < 0) {
            value = 0;
        } else if (value > 1) {
            value = 1;
        }
        this._progress = value;

        let len = this.polygonPoing.length
        if (len <= 1) {
            return;
        }
        let index = Math.floor((len-1) * value);
        // if (index > 0) {
        //     index = index - 1;
        // }
        // if (value >= 1) {
        //     index = index - 1;
        // }
        // 清空画布
        const graphics = this.graphics;
        graphics.clear();

        let sPos = this.polygonPoing[0];
        graphics.moveTo(sPos.x, sPos.y);
        for (let i = 1; i <= index; i++) {
            let pos = this.polygonPoing[i%len];
            graphics.lineTo(pos.x, pos.y);
        }

        if (value >= 1) {
            // graphics.lineTo(sPos.x, sPos.y);
        } else {
            sPos = this.polygonPoing[index];
            let ePos = this.polygonPoing[(index+1) % len];
            let n = 1 / (len-1);
            let p = (value % n) / n;

            graphics.lineTo(sPos.x + (ePos.x - sPos.x) * p, sPos.y + (ePos.y - sPos.y) * p);
        }
        graphics.stroke();
    }

    /**
     * 缓动进度
     * @param duration 时长
     * @param progress 目标进度
     */
    public to(duration: number, progress: number) {
        return new Promise<void>(res => {
            this.stop();
            this.curTweenRes = res;
            this.curTween = cc.tween<PolygonProgressBar>(this)
                .to(duration, { progress })
                .call(() => {
                    this.curTween = null;
                    this.curTweenRes = null;
                })
                .call(res)
                .start();
        });
    }

    /**
     * 停止当前缓动
     */
    public stop() {
        if (this.curTween) {
            this.curTween.stop();
            this.curTween = null;
        }
        if (this.curTweenRes) {
            this.curTweenRes();
            this.curTweenRes = null;
        }
    }

    clearLine() {
        this.graphics.clear();
    }

    // update (dt) {}
}
